import React, { useEffect, useState } from 'react'
import { Box, List, Text } from 'grommet'
import { useSelector } from 'react-redux'
import { I18n } from 'galarm-config'
import { Selectors } from 'galarm-shared'
import SearchBar from './SearchBar'
import UnifiedAlarmSummary from './UnifiedAlarmSummary'

const { makeMissedAlarmsInCategorySelector } = Selectors

const missedAlarmsInCategorySelector = makeMissedAlarmsInCategorySelector()

const ExpiredAlarmScreen = ({ showSearchBar, hideSearchBar }) => {
  const categorizedAlarmView = useSelector(
    state => state.userSettings.categorizedAlarmView
  )
  const currentlySelectedAlarmCategoryId = useSelector(
    state => state.appState.currentlySelectedAlarmCategoryId
  )
  const activeAlarmCategoryId = categorizedAlarmView
    ? currentlySelectedAlarmCategoryId
    : ''
  const alarms = useSelector(state =>
    missedAlarmsInCategorySelector(state, {
      id: activeAlarmCategoryId
    })
  )
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (!showSearchBar) {
      setSearchText('')
    }
  }, [showSearchBar])

  const filteredAlarms = alarms.filter(
    alarm =>
      alarm.name.toLowerCase().includes(searchText.toLowerCase()) ||
      alarm.notes.toLowerCase().includes(searchText.toLowerCase())
  )

  return (
    <Box flex={{ shrink: 0 }} style={{ paddingBottom: '70px' }}>
      {showSearchBar && (
        <SearchBar
          onChangeText={setSearchText}
          searchText={searchText}
          onCloseSearchBar={hideSearchBar}
          focus
        />
      )}
      {filteredAlarms.length === 0 ? (
        <Box pad="medium" flex justify="center" align="center">
          <Text color="textColor">{I18n.t('noExpiredAlarms')}</Text>
        </Box>
      ) : (
        <List
          border={false}
          margin={{ vertical: 'small' }}
          pad={{ vertical: 'xsmall', horizontal: 'small' }}
          data={filteredAlarms}
          // eslint-disable-next-line react/no-children-prop
          children={UnifiedAlarmSummary}
        />
      )}
    </Box>
  )
}

export default ExpiredAlarmScreen
